module.exports = __webpack_public_path__ + "static/img/活动策划案例02.9048caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/活动策划案例02.jpg
// module id = HuAV
// module chunks = 3